<template>
  <div class="copy-quotation">

    <template v-if="isCreatingCopy">
      <div id="spinner-screen" class="full-screen">
          <div class="spinner-wrapper loading-quotes">
            <div class="loader"></div>
              <span v-translation="{ type: 'label', code: 'label_proc_copying_quote'}"></span>
          </div>
      </div>
    </template>

    
    <template v-if="showButtonText">
      <li class="text-link" @click.stop="copyQuotationAction()">
        <i class="fa fa-copy"></i>
          <span v-translation="{ type:'button', code: 'button_copy_quote' }"></span>
      </li>
    </template>
    <template v-else>
        <i class="fa fa-copy" @click.stop="copyQuotationAction()"></i>
    </template>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    quoteId: { type: String, required: true },
    debtorId: { type: String, required: true },
    showToastOnCompletion: { type: Boolean, required: false },
    refreshListOnCompletion: { type: Boolean, required: false },
    showButtonText: { type: Boolean, required: false }
  },
  data() {
    return {
      isCreatingCopy: false
    }; 
  },
  computed: {
    ...mapGetters(['language']),
  },
  methods: {
    ...mapActions('quotations', ['copyQuotation']),
    copyQuotationAction() {

      this.isCreatingCopy = true;

      this.copyQuotation({ debtorId: this.debtorId, quotationId: this.quoteId }).then(newQuoteId => {
          // Handle the resolved state
          this.isCreatingCopy = false;
          this.showSuccessMessage(newQuoteId);
          this.$emit('onCopiedQuote');
          // Do something with the response
      })
      .catch(error => {
          console.error(error);
          this.isCreatingCopy = false;
      });
    },
    showSuccessMessage(quotationNumber) {
      var detailsUrl = new URL(location.origin + "/" + this.language + "/bespoke/account/quotationdetails.aspx");
      detailsUrl.searchParams.append('quoteid', quotationNumber);
      var title = window.vue.translations.title.title_toast_copy_quote;
      var text = window.vue.translations.label.label_toast_copy_quote.replace("[1]", quotationNumber)
      var header = `<h4><i class="fa fa-check-circle"></i>${title}</h4>`;
      var anchor = `<p><a href='${detailsUrl}'>${text}</a>`;
      var html = header + anchor;

      window.showToast(html);
    }
  }
}
</script>

<style>

</style>